import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AdminDashboardScope} from '@features/admin-panel/models/admin-dashboard.models';

/** One choice in the scope switch: the `Scope` query value it sends and its label. */
export interface AdminDashboardScopeOption {
  key: AdminDashboardScope;
  label: string;
}

/**
 * The Admin dashboard's Clients / Non-clients switch. Every open starts on Non-clients on the dev, QA and stage
 * clusters and on Clients (companies in Client Manager) elsewhere; the dashboard picks it and binds it to `value`.
 * The pick is not persisted. Switching shows the same dashboard for the other population.
 */
@Component({
  standalone: false,
  selector: 'app-admin-dashboard-scope-switch',
  templateUrl: './admin-dashboard-scope-switch.component.html',
  styleUrls: ['./admin-dashboard-scope-switch.component.scss']
})
export class AdminDashboardScopeSwitchComponent {
  @Input() value: AdminDashboardScope = 'Clients';
  @Output() valueChange = new EventEmitter<AdminDashboardScope>();

  readonly options: AdminDashboardScopeOption[] = [
    {key: 'Clients', label: 'Clients'},
    {key: 'NonClients', label: 'Non-clients'}
  ];

  onChange(value: AdminDashboardScope): void {
    if (value === this.value) {
      return;
    }
    this.value = value;
    this.valueChange.emit(value);
  }
}
